import { Component } from '@angular/core';
import { 
  NavController, 
  Events, 
  PopoverController,
  ModalController 
} from 'ionic-angular';

// Pages
import { InstructorAddEditPage } from './instructor-add-edit';

// Popovers
import { ListActionsPopoverPage } from '../../components/popovers/list-actions.popover';

// Modals
import { EducationModalPage } from '../../components/modals/education.modal';

// Providers
import { InstructorsService } from '../../providers/instructors/instructors-service';
import { ProvidersService } from '../../providers/providers/providers-service';

// Helpers
import { HelperCsvService } from '../../providers/helpers/helper-csv-service';

@Component({
  selector: 'page-instructors',
  templateUrl: 'instructors.html'
})
export class InstructorsPage {
  headerData: any = {};
  instructors: any = [];
  providers: any = [];
  instructorsCopy: any = [];
  searchResults: boolean = false;
  filterText: string = 'Approved';
  filterProvider: string = '0';
  defaultStatus: string = 'Approved';
  checkedItems: any = [];

  constructor(
    public navCtrl: NavController,
    public events: Events,
    public instructorsService: InstructorsService,
    public providersService: ProvidersService,
    public popoverCtrl: PopoverController,
    public modalCtrl: ModalController,
    public helperCsvService: HelperCsvService
  ) {
    this.headerData.title = 'Instructors';
    this.getProviders();
    this.getInstructors();
  }

  getInstructors()
  {
    this.instructorsService.getInstructorsByStatus( this.defaultStatus ).subscribe( data => {
      this.instructors = data;
      for ( let item in this.instructors )
      {
        this.instructorsCopy.push( this.instructors[item] );
      }
    });
  }

  getProviders()
  {
    this.providersService.getProviders()
      .subscribe( data => {
        this.providers = data;
      });
  }

  filterInstructors( filterType, filterVar )
  {
    switch ( filterType )
    {
      case 'employer':
        this.filterProvider = filterVar;
        break;
      case 'status':
        this.filterText = filterVar;
        break;
    }

    console.log(this.filterProvider);
    if ( this.filterProvider === 'All' && this.filterText === 'All' )
    {
      this.instructors.length = 0;

      for ( var item in this.instructorsCopy )
      {
        this.instructors.push( this.instructorsCopy[item] );
      }
    } else {
      this.instructorsService.filterInstructors( this.filterProvider, this.filterText )
        .subscribe( data => {
          this.instructors = data;
        });
    }
  }

  filterByEmployer( providerId )
  {
    if ( providerId === 'All' )
    {
      this.instructors.length = 0;

      for ( var item in this.instructorsCopy )
      {
        this.instructors.push( this.instructorsCopy[item] );
      }
    } else {
      this.instructorsService.getInstructorsByEmployer( providerId, this.filterText )
        .subscribe( data => {
          this.instructors = data;
        });
    }
  }

  filterByStatus( status )
  {
    this.filterText = status;
    if ( status === 'All' )
    {
      this.instructors.length = 0;

      for ( var item in this.instructorsCopy )
      {
        this.instructors.push( this.instructorsCopy[item] );
      }
    } else {
      this.instructorsService.getInstructorsByStatus( status )
        .subscribe( data => {
          this.instructors = data;
        });
    }
  }

  showInstructorAddEditPage( instructor = null )
  {
    this.navCtrl.push( InstructorAddEditPage, {
      instructor: instructor
    });
  }

  searchInstructors( ev )
  {
    let search_term = ev.target.value;

    if ( search_term && search_term.length > 2 )
    {
      // Clear this.instructors array to prep for search results.
      this.instructors.length = 0;

      this.instructorsService.searchInstructors(search_term).subscribe(data => {
        this.searchResults = true;
        this.instructors = data;

        if ( this.instructors.length === 0 )
        {
          this.searchResults = false;
        }
      });
    } else {
      // Restore original provider list.
      this.instructors.length = 0;

      for ( var item in this.instructorsCopy )
      {
        this.instructors.push( this.instructorsCopy[item] );
      }
      this.searchResults = false;
    }
  }

  clearSearch( ev )
  {
    // Restore original entry list.
    for ( var item in this.instructorsCopy )
    {
      this.instructors.push( this.instructorsCopy[item] );
    }
    this.searchResults = false;
  }

  addRemoveCheckedItems( ev, instructorId, index )
  {
    if ( ev.checked === true )
    {
      this.checkedItems.push( instructorId );
    } else {
      // Remove the id from the checkedItems array.
      for ( let item in this.checkedItems )
      {
        if ( instructorId === this.checkedItems[item] )
        {
          this.checkedItems.splice( item, 1 );
        }
      }
    }
  }  

  getSelectedInstructors()
  {
    let selectedInstructors = [];
    for ( let selectedId in this.checkedItems )
    {
      for ( let instructor in this.instructors )
      {
        if ( this.checkedItems[selectedId] === this.instructors[instructor].instructor_id )
        {
          selectedInstructors.push( this.instructors[instructor] );
        }
      }
    }

    return selectedInstructors;
  }

  presentListActionPopover( ev )
  {
    let popover = this.popoverCtrl.create( ListActionsPopoverPage );
    popover.present({
      ev: ev
    });

    popover.onDidDismiss(data => {
      switch( data )
      {
        case 'add-continuing-ed':
          this.addContinuingEdBulk();
          break;
        case 'delete':
          this.deleteInstructorsBulk();
          break;

      }
    });    
  }

  addContinuingEdBulk()
  {
    let data = this.getSelectedInstructors();
    let modal = this.modalCtrl.create( EducationModalPage, {
      instructors: data
    });
    modal.onDidDismiss( data => {
      // Clear checkboxes.
      this.checkedItems.length = 0;
    });
    modal.present();
  }

  exportInstructors()
  {
    this.helperCsvService.exportInstructorList( this.instructors, 'Instructors Export.csv' );
  }

  deleteInstructorsBulk()
  {
    // TODO: Bulk delete of instructors.
  }

  ionViewWillEnter()
  {
    if ( !this.searchResults )
    {
      //this.getInstructors();
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/instructors/instructors.ts